import Typography from "@mui/material/Typography";
import Zoom from "@mui/material/Zoom";
import React from "react";
import { StyledMessageTooltip } from "../../styled/labels";

const MessagesTooltip = ({ values, children }) => {
  return (
    <StyledMessageTooltip.HtmlTooltip
      arrow
      TransitionComponent={Zoom}
      placement="left"
      title={
        <React.Fragment>
          {values.map((value) => (
            <StyledMessageTooltip.Container key={value}>
              <Typography variant="body2">{value}</Typography>
            </StyledMessageTooltip.Container>
          ))}
        </React.Fragment>
      }>
      {children}
    </StyledMessageTooltip.HtmlTooltip>
  );
};

export default MessagesTooltip;
